import { FieldTypeMap, RuleLogicMap } from '../../../../common/common'

export const EMPTY_CHECK_SELECT_CONTENT_VALUE = '-'

export const isNumericFieldType = (fieldType) => {
  return String(fieldType) === FieldTypeMap.number
}

export const isNumericCompareLogic = (contentLogicType) => {
  return contentLogicType === RuleLogicMap.equal
    || contentLogicType === RuleLogicMap.greaterThan
    || contentLogicType === RuleLogicMap.lessThan
}

export const isEmptyCheckLogic = (contentLogicType) => {
  return contentLogicType === RuleLogicMap.isEmpty
    || contentLogicType === RuleLogicMap.isNotEmpty
}

const FIELD_GROUPS = [
  {
    label: '报名字段',
    isMatch: (field) => {
      return String(field.fieldType) !== '11' && field.fieldFromType !== '1'
    }
  },
  {
    label: '职位字段',
    isMatch: (field) => {
      return field.fieldFromType === '1'
    }
  },
  {
    label: '附件字段',
    isMatch: (field) => {
      return String(field.fieldType) === '11'
    }
  }
]

export const buildGroupedFieldSelectOptions = (fields, options = {}) => {
  const {
    valueKey = 'fieldCode',
    excludeFieldCodes = []
  } = options

  const filteredFields = (fields || []).filter(field => {
    return field?.fieldCode && !excludeFieldCodes.includes(field.fieldCode)
  })

  return FIELD_GROUPS.map(group => {
    const groupFields = filteredFields.filter(group.isMatch)
    if (!groupFields.length) {
      return null
    }

    return {
      label: group.label,
      options: groupFields.map(field => {
        return {
          label: field.fieldName,
          value: valueKey === 'fieldName' ? field.fieldName : field.fieldCode,
          field
        }
      })
    }
  }).filter(Boolean)
}
